"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchResubscribeEmail = exports.FetchResubscribeEmail = exports.FetchResubscribeEmailActionTypes = exports.fetchOptinFollowupEmail = exports.FetchOptinFollowupEmail = exports.FetchOptinFollowupEmailActionTypes = exports.fetchOptinEmail = exports.FetchOptinEmail = exports.FetchOptinEmailActionTypes = exports.SubscriptionEmailsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var SubscriptionEmailsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_OPTIN_EMAIL: null,
  FETCH_OPTIN_FOLLOWUP_EMAIL: null,
  FETCH_RESUBSCRIBE_EMAIL: null
}, 'email');
exports.SubscriptionEmailsActionTypes = SubscriptionEmailsActionTypes;
var FetchOptinEmailActionTypes = (0, _actions.createRequestTypes)(SubscriptionEmailsActionTypes.FETCH_OPTIN_EMAIL);
exports.FetchOptinEmailActionTypes = FetchOptinEmailActionTypes;
var FetchOptinEmail = (0, _actions.createRequestActions)(FetchOptinEmailActionTypes);
exports.FetchOptinEmail = FetchOptinEmail;
var fetchOptinEmail = (0, _fluxActions.createAction)(SubscriptionEmailsActionTypes.FETCH_OPTIN_EMAIL);
exports.fetchOptinEmail = fetchOptinEmail;
var FetchOptinFollowupEmailActionTypes = (0, _actions.createRequestTypes)(SubscriptionEmailsActionTypes.FETCH_OPTIN_FOLLOWUP_EMAIL);
exports.FetchOptinFollowupEmailActionTypes = FetchOptinFollowupEmailActionTypes;
var FetchOptinFollowupEmail = (0, _actions.createRequestActions)(FetchOptinFollowupEmailActionTypes);
exports.FetchOptinFollowupEmail = FetchOptinFollowupEmail;
var fetchOptinFollowupEmail = (0, _fluxActions.createAction)(SubscriptionEmailsActionTypes.FETCH_OPTIN_FOLLOWUP_EMAIL);
exports.fetchOptinFollowupEmail = fetchOptinFollowupEmail;
var FetchResubscribeEmailActionTypes = (0, _actions.createRequestTypes)(SubscriptionEmailsActionTypes.FETCH_RESUBSCRIBE_EMAIL);
exports.FetchResubscribeEmailActionTypes = FetchResubscribeEmailActionTypes;
var FetchResubscribeEmail = (0, _actions.createRequestActions)(FetchResubscribeEmailActionTypes);
exports.FetchResubscribeEmail = FetchResubscribeEmail;
var fetchResubscribeEmail = (0, _fluxActions.createAction)(SubscriptionEmailsActionTypes.FETCH_RESUBSCRIBE_EMAIL);
exports.fetchResubscribeEmail = fetchResubscribeEmail;